export const flagCompleteToday = "o1T3Gb";
export const flagCompleteTomorrow = "mTyP4c";
export const flagCompleteThisWeek = "Tp1uIc";
export const flagCompleteNextWeek = "Mjd_Od";
export const flagCompleteNoDate = "uaya5d";
export const flagCompleteCustom = "uZ0Ol";
export const flagCompleteAddReminder = "epMQne";
export const flagCompleteEditReminder = "jKiozc";
export const flagCompleteMarkComplete = "b$1J8d";
export const flagCompleteClearFlag = "uGMZ2";
export const flagTodayButtonDescContextMenu = "qj1cjb";
export const flagTomorrowButtonDescContextMenu = "YC1Ybe";
export const flagThisWeekButtonDescContextMenu = "fmmeW";
export const flagNextWeekButtonDescContextMenu = "QvVbbc";
export const flagNoDateButtonDescContextMenu = "OCKC_d";
export const flagMarkCompleteButtonDescContextMenu = "FhMomb";
export const flagCustomButtonDescContextMenu = "oGcmwb";
export const flagClearFlagButtonDescContextMenu = "kEM91c";
export const flagAddReminderButtonDescContextMenu = "gTxV_";
export const flagEditReminderButtonDescContextMenu = "Fw3kH";
export default {flagCompleteToday,flagCompleteTomorrow,flagCompleteThisWeek,flagCompleteNextWeek,flagCompleteNoDate,flagCompleteCustom,flagCompleteAddReminder,flagCompleteEditReminder,flagCompleteMarkComplete,flagCompleteClearFlag,flagTodayButtonDescContextMenu,flagTomorrowButtonDescContextMenu,flagThisWeekButtonDescContextMenu,flagNextWeekButtonDescContextMenu,flagNoDateButtonDescContextMenu,flagMarkCompleteButtonDescContextMenu,flagCustomButtonDescContextMenu,flagClearFlagButtonDescContextMenu,flagAddReminderButtonDescContextMenu,flagEditReminderButtonDescContextMenu};